import React from 'react'
import { graphql, useStaticQuery} from 'gatsby'
import ConsiderReading from './ConsiderReading'

const ConsiderReadingWrapper = ({blog}) => {
  const data = useStaticQuery(graphql`
    query blogBySlug {
      allMarkdownRemark {
        edges {
          node {
            fields {
              slug
              date
            }
            frontmatter {
              title
              date
              category
              tags
              layout
              assets {
                hero
              }
            }
          }
        }
      }
    }
  `);
  return (
    <ConsiderReading
      fileEdges={data.allMarkdownRemark.edges}
      blog={blog}
    ></ConsiderReading>
  )
}

export default ConsiderReadingWrapper
